/**
 * Attribution for home-screen entries. The saved entry URL carries `src=home`
 * (iOS: written by the popup via replaceState before the customer saves;
 * Android: baked into the manifest start_url by the backend), so an arrival
 * with that param is a customer coming back through their saved icon.
 * 桌面入口归因。保存的 URL 带 `src=home`（iOS 由弹窗在保存前 replaceState 写入；
 * Android 由后端 manifest 的 start_url 携带），带参进站即视为从桌面图标回访。
 *
 * Deduped per tab session (same pattern as qrScanTracking): a WebAPK launch or
 * icon tap opens a fresh tab session, in-app navigation does not re-fire.
 * 按标签页会话去重（与 qrScanTracking 同款）：点图标是新会话，站内跳转不重报。
 */

export const A2HS_SRC_PARAM = 'src'
export const A2HS_SRC_VALUE = 'home'
const SESSION_KEY = 'mm_a2hs_open_tracked'

/**
 * Pure: does this page view come through a saved home-screen entry
 * (src=home)? No session dedup — that belongs to tracking only.
 * 纯判定：本次进站是否走的保存过的桌面入口（src=home）？不做会话去重——
 * 去重只属于埋点。
 *
 * @param {string} search - location.search
 * @returns {boolean}
 */
export function isHomeScreenEntry(search) {
  if (!search) return false
  try {
    return new URLSearchParams(search).get(A2HS_SRC_PARAM) === A2HS_SRC_VALUE
  } catch (e) {
    return false
  }
}

/** Convenience wrapper against the live browser. 读当前浏览器的薄包装。 */
export function isHomeScreenEntryHere() {
  if (typeof window === 'undefined') return false
  try {
    return isHomeScreenEntry(window.location.search)
  } catch (e) {
    return false
  }
}

/**
 * Pure decision: should this page view be counted as a home-screen return
 * visit? 纯判定：本次进站是否计一次桌面图标回访。
 *
 * @param {string} search - location.search
 * @param {Object} sessionStore - sessionStorage-like ({getItem, setItem})
 * @returns {boolean} true exactly once per tab session when src=home is present
 */
export function shouldTrackA2hsOpen(search, sessionStore) {
  if (!search || !sessionStore) return false
  if (!isHomeScreenEntry(search)) return false
  try {
    if (sessionStore.getItem(SESSION_KEY)) return false
    sessionStore.setItem(SESSION_KEY, '1')
    return true
  } catch (e) {
    return false // 存储不可用就少记一次，绝不抛错
  }
}

/** Convenience wrapper against the live browser. 直接读当前浏览器的薄包装。 */
export function shouldTrackA2hsOpenHere() {
  if (typeof window === 'undefined') return false
  try {
    return shouldTrackA2hsOpen(window.location.search, window.sessionStorage)
  } catch (e) {
    return false
  }
}
